import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuicksighDashboard } from '@app/@shared/models/reverse-engineering/analysis.models';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { QuicksightDashboardEmbed } from '../market-analysis/dashboard.models';
import { map } from 'rxjs/operators';
import { Content, StashResponse } from './content.model';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private readonly metaUrl = environment.metaServiceBaseUrl;
  private readonly stashUrl = environment.stashServiceBaseUrl;

  constructor(
    private readonly http: HttpClient,
  ) { }

  /**
   * Gets asset content by assetId
   * @param assetId
   * @returns asset content object
   */
  getAssetContent(assetId: string): Observable<Content> {
    return this.http.get(`${this.metaUrl}/asset_content/${assetId}`).pipe(
      map((response: any) => ({
        id: response.assetId,
        name: response.name,
        assetClassification: response.asset_classification,
        content: response.content,
        downloadEnabled: response.download_enabled,
      })
    ));
  }


  /**
   * Gets and quicksight url with a gibven assetId
   * @param assetId
   * @returns an quicksight url
   * @deprecated
   */
  getQuicksightEmbeddedURL(assetId: string): Observable<string> {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    const url = `${this.metaUrl}/dashboardasset/embedurl/${assetId}`;

    return this.http.get(url, { headers, responseType: 'text' });
  }

  getQuicksightDashboard(assetId: string): Observable<QuicksightDashboardEmbed> {
    return this.http.get(`${this.metaUrl}/asset_content/${assetId}`).pipe(
      map((response: any) => ({
        embedUrl: response.content.embedUrl,
        downloadEnabled: response.download_enabled.data_grid,
        hasRawData: response.content.hasRawData
      }))
    );
  }

  getQuicksightRawDataEmbeddedURL(assetId: string): Observable<string> {
    return this.http.get(`${this.metaUrl}/asset_content/${assetId}`, { params: { fetchRawData: true } }).pipe(
      map((response: any) => response.content.embedUrl)
    );
  }
  /**
   * Sends a body that needs the endpoint to store the information, returns an id (string)
   * @returns id
   */
  postQuicksightSheetAndParameters(qsState: QuicksighDashboard): Observable<string> {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    const body = JSON.stringify(qsState);
    const url = `${this.stashUrl}/stash`;
    return this.http.post<StashResponse>(url, body, { headers }).pipe(
      map(response => response.id),
    );
  }

  /**
   * Get the sheet id and parameters of the dashboard
   */
  getQuicksightSheetAndParameters(id: string): Observable<QuicksighDashboard> {
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/json');
    const url = `${this.stashUrl}/stash/${id}`;

    return this.http.get(url, { headers }).pipe(
      map((resp: any) => {
        return {
          sheetId: resp.sheetId,
          parameters: resp.parameters
        }
      })
    );
  }

  getHTMLContent(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'text' });
  }
}
